"use client";
import { BannerRep } from "@/api/home";
import { server } from "@/utils/client";
import { Local } from "@/utils/storage";
import { useEffect, useState } from "react";
import HomeCard from "../_home/HomeCard";
const getActivities = async () => {
    return server
        .request<BannerRep[]>({
            url: "/v1/api/front/activity_home",
            method: "POST",
            data: { click_id: Local.getKey("ban_click_id") ?? undefined },
        })
        .then((res) => {
            if (res.code === 200) {
                return res.data;
            } else {
                return [];
            }
        });
};

const Page = () => {
    const [activities, setActivities] = useState<BannerRep[]>([]);
    useEffect(() => {
        getActivities().then((data) => {
            setActivities(data);
        });
    }, []);
    if (!activities.length) return null;
    return <HomeCard banners={activities}></HomeCard>;
};

export default Page;
